import React, { useEffect, useMemo, useState } from "react";
import Box from "@mui/material/Box";
import { reduxForm } from "redux-form";
import { useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import FormBuilder, { IMedAppFormField } from "../../../../../form";
import { Tag } from "../../../../../../models";

import {
  required,
  minLength,
  minValue as min,
} from "../../../../../form/utils/validations";
import LinearProgress from "@mui/material/LinearProgress";
import Api, { ViewRequest } from "../../../../../../api/medAppApi";
import { useParams } from "react-router";
import { useMutation, useQuery } from "react-query";
import {
  getAppointmentPrice,
  getSpecializationDescription,
} from "../../../../../../helpers";
import { putMessage } from "../../../../../app/store/actions";
import queryClient from "../../../../../../queryClient";

const SpecializationCreateForm: React.FC<any> = ({
  mFields,
  name,
  handleSubmit,
  onSubmit,
}) => {
  const handleSubmitCallback = (value: any) => {
    onSubmit(value);
  };
  return (
    <form onSubmit={handleSubmit(handleSubmitCallback)}>
      {" "}
      <FormBuilder fields={mFields} name={name} />
      <Button type="submit" variant="contained">
        Continue
      </Button>
    </form>
  );
};

const SpecializationCreateReduxForm = reduxForm<any, any>({
  form: "subscription-create",
})(SpecializationCreateForm);

const SpecializationCreateUpdate: React.FC<{
  load: boolean;
}> = ({ load }) => {
  let { id } = useParams<{ id: string }>();
  const dispatch = useDispatch();
  const [specialization, setSpecialization] = useState<Tag | undefined>();

  const check = async (modelId: number) => {
    const criteria: ViewRequest = {
      modelName: "tag",
      modelId,
    };
    let ans = await Api.viewModel<Tag>(criteria);
    if (ans.code !== 200) {
      console.log(ans);
      throw new Error("Cannot Load data");
    }
    return ans.data!.data.payload!;
  };
  const { isLoading, data, isFetching, isError} = useQuery(
    "load-specialization-" + (id || "-1"),
    () => check(parseInt(id || "-1", 10)),
    { enabled: load }
  );

  React.useEffect(() => {
    if(isError) {
     dispatch(putMessage({type: 'error', message: 'Failed to load data'}))
  }},
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [isError]
  );
  useEffect(() => {
    if (!data) {
      return;
    }
    setSpecialization(data!);
  }, [data]);

  const fields: IMedAppFormField[] = useMemo(() => {
    let price = 5000;
    let description = "";
    let name = "";
    if (specialization) {
      name = specialization.name;
      price = getAppointmentPrice(specialization);
      description = getSpecializationDescription(specialization);
    }

    return [
      {
        name: "name",
        label: "Specialization  Name",
        type: "text",
        defaultValue: name,
        validate: [required, minLength(2)],
      },
      {
        name: "price",
        label: "Price",
        type: "number",

        validate: [required, min(1000)],

        defaultValue: price.toString(),
      },

      {
        name: "divider",

        type: "text",
        variant: "divider",
      },
      {
        name: "description",
        label: "Specialization  Description",
        type: "text",
        defaultValue: description,
        inputExtras: {
          multiline: true,
        },
        validate: [required, minLength(2)],
      },
    ];
  }, [specialization]);

  async function createUpdate(values: any) {
    if (specialization) {
      let ans = await Api.updateModel<Tag>({
        modelName: "tag",
        where: { id: specialization.id },
        update: values,
      });
      if (ans.errorData || ans.error) {
        throw new Error(
          ans.errorData?.problems || ans.error || "Something went wrong"
        );
      }
      queryClient.invalidateQueries("load-specialization-" + (id || "-1"));
      return ans.data!.data!.model;
    } else {
      let ans = await Api.createModel<Tag>({
        modelName: "tag",
        payload: {
          ...values,
          type: "specialization",
          description: "Doctor Specialiazation"
        },
      });
      if (ans.errorData || ans.error) {
        throw new Error(
          ans.errorData?.problems || ans.error || "Something went wrong"
        );
      }
      queryClient.invalidateQueries("load-specializations");
      return ans!.data!.data!.payload;
    }
  }

  const { mutate, isLoading: creating } = useMutation({
    mutationKey: "update-create-specialization",
    mutationFn: createUpdate,
    onSuccess: (d) => {
      dispatch(
        putMessage({
          type: "success",
          message: (!!specialization ? "Updated" : "Created") + " successfully",
        })
      );
      setSpecialization(d);
    },
    onError: (error: any) => {
      dispatch(
        putMessage({
          type: "error",
          message: error.message || "something went wrong",
        })
      );
    },
  });

  const handleSubmit = (value: any) => {
    console.log(value);
    mutate({
      name: value.name,
      value: {
        type: "object",
        val: {
          appointmentPrice: value.price,
          description: value.description,
        },
      },
    });
  };

  return (
    <Box
      style={{
        width: "100%",
      }}
    >
      <Box
        sx={{
          width: "70%",
          maxWidth: "700px",
          minWidth: "250px",
          marginLeft: "1em",
        }}
      >
        {(creating || isLoading || isFetching) && <LinearProgress />}
        <SpecializationCreateReduxForm
          mFields={fields}
          namel="kosy-2"
          onSubmit={handleSubmit}
        />
      </Box>
    </Box>
  );
};

export default SpecializationCreateUpdate;
